export const aiJobDetailMarkup = String.raw`<!-- ====== AI JOB DETAIL VIEW ====== -->
    <div class="view" id="view-ai-job-detail">
      <div class="ai-job-detail-wrap">
        <div class="topic-back-row">
          <button class="btn btn-default btn-sm topic-back-pill" data-proto-click="backFromAiJobDetail()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>
            Back
          </button>
        </div>

        <!-- Header: title + subtitle + status -->
        <div class="ai-job-detail-header">
          <h1 class="heading-1" style="font-size:28px;margin-bottom:0;line-height:1.25;" id="aiJobDetailTitle">Loading…</h1>
          <p class="ai-job-detail-subtitle" id="aiJobDetailSubtitle"></p>
          <div class="ai-job-detail-meta">
            <span class="pill" id="aiJobDetailStatus">-</span>
            <span class="ai-job-detail-time" id="aiJobDetailTime"></span>
          </div>
        </div>

        <!-- Section 1: Topic Basics (Wizard Step 1) -->
        <section class="ai-job-detail-section">
          <h3 class="ai-job-detail-section-title">Topic Basics</h3>
          <div class="ai-job-detail-field">
            <span class="ai-job-detail-field-label">Title</span>
            <span class="ai-job-detail-field-value" id="aiJobDetailTitleValue">-</span>
          </div>
          <div class="ai-job-detail-field">
            <span class="ai-job-detail-field-label">Subtitle</span>
            <span class="ai-job-detail-field-value" id="aiJobDetailSubtitleValue">-</span>
          </div>
        </section>

        <!-- Section 2: Reference Material (Wizard Step 2) -->
        <section class="ai-job-detail-section" id="aiJobDetailLinksSection">
          <h3 class="ai-job-detail-section-title">Reference Material</h3>
          <div id="aiJobDetailLinks" class="ai-job-detail-links"></div>
          <div id="aiJobDetailAttachSection" hidden>
            <h4 class="ai-job-detail-subsection-title">Attachments</h4>
            <div id="aiJobDetailAttach" class="ai-job-detail-attachments"></div>
          </div>
        </section>

        <!-- Section 3: Learning Preferences (Wizard Step 3) -->
        <section class="ai-job-detail-section">
          <h3 class="ai-job-detail-section-title">Learning Preferences</h3>
          <div class="ai-job-detail-field">
            <span class="ai-job-detail-field-label">What do you want to learn?</span>
            <span class="ai-job-detail-field-value" id="aiJobDetailDesc">-</span>
          </div>
          <div class="ai-job-detail-field">
            <span class="ai-job-detail-field-label">Chapter Count</span>
            <span class="ai-job-detail-field-value" id="aiJobDetailChapters">-</span>
          </div>
          <div id="aiJobDetailPrefsSection" hidden>
            <div class="ai-job-detail-pref-group" id="aiJobDetailStrengths"></div>
            <div class="ai-job-detail-pref-group" id="aiJobDetailWeaknesses"></div>
          </div>
        </section>

        <!-- Generated Topic link (if completed) -->
        <section id="aiJobDetailTopicSection" class="ai-job-detail-topic-card" hidden>
          <p>This submission has been generated into a topic.</p>
          <button class="btn btn-outline" id="aiJobDetailViewTopic" data-proto-click="">View Generated Topic</button>
        </section>
      </div>
    </div>
    `;
